import type { ReactElement } from 'react';
import Banner from 'components/shared/Banner';

type Props = {
  onClick: () => void;
  btnClassName?: string;
};

function CreditCardExpirationBanner({ onClick, btnClassName }: Props): ReactElement {
  return (
    <Banner.Warning
      button={(
        <button
          className={`c-button c-button--secondary ${btnClassName}`}
          type="button"
          onClick={onClick}
        >
          Add Payment Info
        </button>
      )}
    >
      <>
        <strong>Add Payment</strong>
        <br />
        Warning: Your subscription will expire soon without a valid
        payment method, please update your payment information.
      </>
    </Banner.Warning>
  );
}

export default CreditCardExpirationBanner;
